export default "__VITE_ASSET__110dcc6b__"